import * as React from "react";
import { isEqual } from "lodash";
import { Form } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { LinkObject } from "@teamprevent/common/model";

import { OrgStructureDetailModel } from "../orgStructure/models";

import { ALL_ORG_STRUCTURES, CustomerUserCaseTypeOrgStructures } from "./models";

interface Props {
    orgStructures: OrgStructureDetailModel[];
    caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures;
    onCaseTypeOrgStructuresChanged: (
        caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures,
        orgStructures: LinkObject[],
        includeLinkedImmunisationCases?: boolean) => void;
    getAllValue: () => { id: string; name: string };
}

export const OrgStructuresDropDownSection: React.FunctionComponent<Props> = ({
    caseTypeOrgStructure, onCaseTypeOrgStructuresChanged, getAllValue, ...props
}: Props) => {

    const levelOneOrgStructures = React.useMemo(() => props.orgStructures?.filter(os => !os.parentId), [props.orgStructures]);

    const onOrgStructuresDropDownChanged = React.useCallback(( orgStructureIds: string[]) => {
        const orgStructures = orgStructureIds.map(orgStructureId => {
            if (orgStructureId === ALL_ORG_STRUCTURES) {
                return getAllValue();
            }
            return levelOneOrgStructures.find(orgStruct => orgStruct.id === orgStructureId);
        }).filter(os => os);
        if (!isEqual(caseTypeOrgStructure.orgStructures, orgStructures)) {
            onCaseTypeOrgStructuresChanged(caseTypeOrgStructure, orgStructures.map(os => { return { id: os.id, name: os.name }; }));
        }
    }, [caseTypeOrgStructure, levelOneOrgStructures, onCaseTypeOrgStructuresChanged, getAllValue]);

    const mapOrgStructures = () => {
        return levelOneOrgStructures
            && [
                { key: ALL_ORG_STRUCTURES, value: ALL_ORG_STRUCTURES, text: ALL_ORG_STRUCTURES },
                ...levelOneOrgStructures.map(orgStructure => ({ value: orgStructure.id, text: orgStructure.name }))
            ];
    };

    return (
        <Form.Field>
            <Input.DropdownMulti
                value={caseTypeOrgStructure.orgStructures?.map(org => org.id)}
                options={mapOrgStructures()}
                onChange={onOrgStructuresDropDownChanged}
            />
        </Form.Field>
    );
};
